module.exports = __webpack_public_path__ + "static/img/HOME2 1024x768.33d3ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/match/HOME2 1024x768.jpg
// module id = epvL
// module chunks = 47